













































































import settings from '../settings.coffee'
import gql from '@/gqlService.coffee'
import queries from "@/gql/queries.coffee"
import mutations from "@/gql/mutations.coffee"
    
export default {
    name: 'Link',
    data: ()->
        return {
            links: [],
            loading: false
            showAddLinkModal: false,
            isEditing: false,
            showAddLinkModal: false,
            newLink: {
                uid: null,
                label: '',
                href: ''
            }
        }
    mounted: ()->
        @fetchLinks()
    methods:
        fetchLinks: ()->
            r = await queries.run("get_links")
            if r.ok
                @links = r.body.data.link_set

        openAddLinkModal: () ->
            @isEditing = false
            @showAddLinkModal = true

        openEditLinkModal: (link) ->
            @isEditing = true
            @newLink = {...link}
            @showAddLinkModal = true

        closeAddLinkModal: () ->
            @showAddLinkModal = false
            @newLink = {uid: null, label: '', href: ''}

        addLink: () ->
            loading = true
            r = await mutations.run('add_link', [@newLink.label, @newLink.href])
            if r.ok
                @links.push(r.body.data.create_link.link)
                @closeAddLinkModal()
            else
                console.error('Error adding link:', error)
            @loading = false

        updateLink: () ->
            loading = true
            r = await mutations.run('update_link', [@newLink.uid, @newLink.label, @newLink.href])
            if r.ok
                updatedLink = r.body.data.update_link.link
                @fetchLinks()
                @closeAddLinkModal()
            else
                console.error('Error updating link:', error)
            @loading = false
        deleteLink: (uid) ->
            @loading = true
            response = await mutations.run('delete_link',[uid])
            if response.ok
                @links = @links.filter((link) -> link.uid != uid)
            else
                console.error('Error updating link:', error)
            @loading = false


}
